// @flow
import React from "react";
import styled from "styled-components";

const Icon = styled.svg`
  display: block;
`;

const SMSIcon = () => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width="24.9"
    height="21.723"
    viewBox="0 0 24.9 21.723"
    fill="currentColor"
  >
    <path
      d="M19.541,31.26H5.359A5.425,5.425,0,0,0,0,36.736V42.16a5.425,5.425,0,0,0,5.359,5.476h8.964l6.517,5.347V47.471A5.454,5.454,0,0,0,24.9,42.16V36.736A5.425,5.425,0,0,0,19.541,31.26ZM5.734,41.787a3.43,3.43,0,0,1-1.566-.337l.267-1.081a2.943,2.943,0,0,0,1.3.367c.456,0,.644-.159.644-.407s-.149-.367-.714-.555c-1-.337-1.388-.882-1.378-1.457,0-.9.774-1.586,1.973-1.586a3.249,3.249,0,0,1,1.369.277L7.36,38.05a2.374,2.374,0,0,0-1.051-.278c-.367,0-.575.149-.575.4,0,.228.188.347.783.555.922.317,1.309.783,1.318,1.5C7.836,41.123,7.122,41.787,5.734,41.787Zm10.34-.1H14.607V39.051c0-.7-.229-1.111-.714-1.111a.737.737,0,0,0-.694.526,1.262,1.262,0,0,0-.059.387v2.835H11.672V38.971c0-.615-.218-1.031-.695-1.031a.767.767,0,0,0-.7.546,1,1,0,0,0-.059.377v2.825H8.747v-3.3c0-.6-.02-1.12-.04-1.546H9.977l.069.654h.03a1.682,1.682,0,0,1,1.467-.763,1.374,1.374,0,0,1,1.328.822h.02a2.164,2.164,0,0,1,.625-.584,1.75,1.75,0,0,1,.923-.238c.932,0,1.636.654,1.636,2.1v2.856Zm2.486.1a3.43,3.43,0,0,1-1.566-.337l.267-1.081a2.943,2.943,0,0,0,1.3.367c.456,0,.644-.159.644-.407s-.149-.367-.714-.555c-1-.337-1.388-.882-1.378-1.457,0-.9.774-1.586,1.973-1.586a3.252,3.252,0,0,1,1.369.277l-.267,1.041a2.374,2.374,0,0,0-1.051-.278c-.367,0-.575.149-.575.4,0,.228.188.347.783.555.922.317,1.309.783,1.318,1.5C20.662,41.123,19.948,41.787,18.56,41.787Z"
      transform="translate(0 -31.26)"
    />
  </Icon>
);

export default SMSIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/Social/SMS.js